export default theme => ({
  root: {
    width: '340px',
    maxWidth: '100%'
  },
  header: {
    backgroundColor: theme.palette.background.default,
   /*  backgroundImage: 'url("/images/connected_world.svg")', */
    backgroundPositionX: 'right',
    backgroundPositionY: 'center',
    backgroundRepeat: 'no-repeat',
    backgroundSize: 'contain',
    paddingBottom: '10px',
    paddingLeft: '20px',
    paddingRight: '20px',
    paddingTop: '20px'
  },
  subtitle: {
    color: theme.palette.text.secondary
  },
  content: {},
  listItem: {
    padding: 0,
    cursor: 'pointer',
    '&:hover': {
      backgroundColor: theme.palette.background.default
    }
  },
  FeedbackButton: {
    marginLeft: 'auto',
    [theme.breakpoints.down('sm')]: {
      marginLeft: 'auto',
    },
    color: '#e6e6e6',
  },
  listItemIcon: {
    backgroundColor: 'rgba(0, 0, 0, 0.03)',
    padding: '10px',
    borderRadius: '50%',
    marginRight: 0,
    width: 40,
    height: 40,
    justifyContent: 'center',
    alignContent: 'center'
  },
  listItemTextSecondary: {
    marignTop: '4px',
    color: theme.palette.text.secondary
  },
  arrowForward: {
    color: theme.palette.text.secondary,
    height: '16px',
    width: '16px'
  },
  footer: {
    paddingBottom: theme.spacing(1),
    display: 'flex',
    justifyContent: 'center',
    paddingTop: theme.spacing(1)
  },
  empty: {
    textAlign: 'center',
    padding: theme.spacing(3)
  },
  emptyImageWrapper: {
    marginBottom: theme.spacing(3)
  },
  emptyImage: {
    width: '240px',
    maxWidth: '100%',
    height: 'auto'
  },
  buttonClosed:{
    textAlign:"right",
    color:'black'
  }
});
